import { createContext, useContext } from "react";
import { IdMeButtonProps } from "../types";

interface BannerContextType {
  isSignedIn?: boolean;
  customerId?: string;
  idMeButton?: IdMeButtonProps;
}

export const BannerContext = createContext<BannerContextType | undefined>(undefined);

export const useBannerContext = () => {
  const context = useContext(BannerContext);
  if (!context) {
    throw new Error("useMyComponentContext must be used within a MyComponentProvider");
  }
  return context;
};
